module.exports = __webpack_public_path__ + "img/capa2.a32dd4c3.webp";